import styled from 'styled-components'
import { buttonDivProps } from './interfaces'

export const ButtonDiv = styled.div<buttonDivProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 38px;
  border: 3px solid ${({ borderColor }) => borderColor || 'transparent'};
  color: ${({ textColor }) => textColor || '#ff3920'};
  border-color: ${({ borderColor }) => borderColor || 'rgba(255, 176, 0, 1)'};
  background: ${({ background }) => background || 'rgba(255, 176, 0, 1)'};
  font-size: ${({ size }) => size || '20px;'};
  height: ${({ height }) => height || '56px;'};
  width: ${({ width }) => width || '56px;'};
  transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
  transition: transform 0.16s;
  text-align: center;
  ${p =>
    p.anim
      ? 'transform: scale3d(0.65, 0.65, 0.65);'
      : 'transform: scale3d(1, 1,1); '}
  cursor: pointer;
  svg {
    path {
      stroke: ${({ textColor }) => textColor};
    }
  }
  .white {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    transition: transform 0.16s;
    ${p => (p.anim ? 'opacity: 0.5;' : '')}
  }
  &&.disable {
    pointer-events: none;
    opacity: 0.6;
  }
`

/* stroke-dasharray: 43;
stroke-dashoffset: 0;
stroke: ${(p) => (p.isTurboOn ? '#ffb000' : '#d93d32')};
animation: ${(p) => (p.isTurboOn && !p.autoBtn ? svgAnimOn : null)}; */
